import { render, staticRenderFns } from "./register1.vue?vue&type=template&id=71a16650&"
import script from "./register1.vue?vue&type=script&lang=js&"
export * from "./register1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports